import log from 'salvo-lite/log'
import Choices from 'choices.js'
import axios from 'axios'

class Checkout {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._choiceData = JSON.parse(document.querySelector('[data-checkout]').dataset.questions)
        this._form = document.querySelector('[data-customer-information-form]')

        this._choiceOne = this._choiceData.where_did_you_hear_about_us

        this._choiceTwo = {
            question: '<span class="red">*</span> Want to know when we&#39;ve got an offer on? (please select one)',
            options: {
                true: 'Yes, please add me to the mailing list to receive two offers a month, each with a substantial discount (your email address will be used for NO other purpose)',
                false: 'No thank you, discounts aren&#39;t my thing'
            },
            warning: 'Please fill in all fields marked *'
        }

        this._choiceThree = 'We will only use your phone number if there is a query with your order.'

        this._checkboxWrapper = ''
        this._choiceObject = ''

        this._acceptEmailMarketing = 'accepts_marketing'
        this._whereDidYouHear = 'where_did_you_hear_about_us'

        this._acceptEmailMarketingLS = localStorage.getItem(this._acceptEmailMarketing)
        this._whereDidYouHearLS = localStorage.getItem(this._whereDidYouHear)

        this._askOnce = false

        this._stepSections = document.querySelector('.step__sections')

        this._realCheckbox = document.querySelector('#checkout_buyer_accepts_marketing')

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        // this._checkLocalStorage()
        this._createChoices()

        this._form.querySelector('[type=submit]').addEventListener('click', (e) => {
            e.preventDefault()

            let optionSelected = false

            let inputs = document.querySelectorAll('.option-wrapper input')
            let select = document.querySelector('.checkout-marketing-select option')

            inputs.forEach((input) => {
                if (input.checked && select.value !== 'Please Select') optionSelected = true
            })

            if (optionSelected) {
                this._form.submit()
            } else {
                let warnFields = document.querySelectorAll('.red')

                warnFields.forEach(el => {
                    el.classList.add('red-checked')
                })

                this._checkboxWrapper.classList.add('field--error')
            }
        })

        let checkboxInputs = this._checkboxWrapper.querySelectorAll('input')
        let checkboxWarning = this._checkboxWrapper.querySelector('p')

        checkboxInputs.forEach((input, i) => {
            input.addEventListener('click', (e) => {
                let other
                i === 0 ? other = 1 : other = 0
                input.checked === true ? checkboxInputs[other].checked = false : input.checked = true
                input.checked === true ? this._realCheckbox.checked = true : this._realCheckbox.checked = false
                if (input.dataset.value === 'true') {
                    this._addCartAttribute({accepts_marketing: true})
                    // input.value = 1
                } else {
                    this._addCartAttribute({accepts_marketing: false})
                    // input.value = 0
                }
                if (checkboxWarning.classList.contains('field-error')) checkboxWarning.classList.remove('field-error')
            })
        })

        this._setDefaultChoices()
    }

    _checkLocalStorage () {
        if (this._acceptEmailMarketingLS) this._checkboxWrapper.querySelector(`input[data-value="${this._acceptEmailMarketingLS}"]`).checked = true
        if (this._whereDidYouHearLS) this._choiceObject.setChoiceByValue(this._whereDidYouHearLS)
    }

    _setDefaultChoices () {
        this._realCheckbox.checked ? this._checkboxWrapper.querySelector('input[data-value="true"').checked = false : this._checkboxWrapper.querySelector('input[data-value="false"').checked = false
        // if (this._acceptEmailMarketingLS) this._checkboxWrapper.querySelector(`input[data-value="${this._acceptEmailMarketingLS}"]`).checked = true
        if (this._whereDidYouHearLS) this._choiceObject.setChoiceByValue(this._whereDidYouHearLS)
    }

    _createChoices () {
        // move contact info element beneath shippin address element

        let contactInfoEl = document.querySelector('.section.section--contact-information')
        this._stepSections.appendChild(contactInfoEl)

        // add phone number field to contact info element

        let phoneEl = document.createElement('input')
        contactInfoEl.appendChild(phoneEl)
        phoneEl.placeholder = 'Phone'
        phoneEl.type = 'tel'
        phoneEl.name = 'checkout[attributes][Phone]'
        phoneEl.value = ''
        phoneEl.setAttribute('aria-required', 'true')
        phoneEl.classList.add('field__input', 'phone-input')

        // add disclaimer underneath phone number field

        let phoneInputDisclaimer = document.createElement('p')
        contactInfoEl.appendChild(phoneInputDisclaimer)
        phoneInputDisclaimer.innerHTML = this._choiceThree
        phoneInputDisclaimer.classList.add('phone-input-disclaimer')

        // element where choices will be placed

        let newEl = document.createElement('div')
        newEl.classList.add('section', 'section--marketing')
        this._stepSections.appendChild(newEl)
        let customerInfoEl = this._stepSections.querySelector('.section.section--marketing')

        // first question

        let questionOne = document.createElement('p')
        questionOne.classList.add('checkout-marketing-question')
        let replace = this._choiceOne.question.charAt(0).replace('*', '<span class="red">*</span>')
        questionOne.innerHTML = `${replace}${this._choiceOne.question.split('*')[1]}`

        // select element and option elements for first question

        let select = document.createElement('select')
        select.classList.add('checkout-marketing-select')
        select.name = 'checkout[attributes][Referral]'

        this._choiceOne.options.forEach((option) => {
            let optionEl = document.createElement('option')
            optionEl.value = option
            select.appendChild(optionEl)
        })

        // second question

        let questionTwo = document.createElement('p')
        questionTwo.classList.add('checkout-marketing-question')
        questionTwo.innerHTML = this._choiceTwo.question

        // choices for second question

        let checkboxWrapper = document.createElement('div')
        let warning = document.createElement('p')
        warning.classList.add('field__message', 'field__message--error')
        warning.innerHTML = this._choiceTwo.warning

        checkboxWrapper.classList.add('checkbox-wrapper')

        for (let option in this._choiceTwo.options) {
            if (!this._choiceTwo.options.hasOwnProperty(option)) continue
            let optionWrapper = document.createElement('div')
            let input = document.createElement('input')
            let label = document.createElement('label')

            optionWrapper.classList.add('option-wrapper')
            input.type = 'checkbox'
            option === 'true' ? input.value = '1' : input.value = '0'
            input.dataset.value = option
            // input.name = 'checkout[buyer_accepts_marketing]'
            input.classList.add('input-checkbox')
            label.innerHTML = this._choiceTwo.options[option]

            optionWrapper.appendChild(input)
            optionWrapper.appendChild(label)
            checkboxWrapper.appendChild(optionWrapper)
        }

        this._checkboxWrapper = checkboxWrapper

        // attach elements to target element

        customerInfoEl.appendChild(questionOne)
        customerInfoEl.appendChild(select)
        customerInfoEl.appendChild(questionTwo)
        customerInfoEl.appendChild(checkboxWrapper)
        checkboxWrapper.appendChild(warning)
        console.log(checkboxWrapper)

        // initialise Choices.js

        // eslint-disable-next-line no-unused-vars

        let choiceEl = document.querySelector('.checkout-marketing-select')
        this._choiceObject = new Choices(choiceEl, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false
        })

        // this._choiceObject.passedElement.element.addEventListener('change', () => {
        //     this._addCartAttribute({where_did_you_hear_about_us: document.querySelector('.checkout-marketing-select option').value})
        // })
    }

    _addCartAttribute (attribute) {
        let key = Object.keys(attribute)[0]
        let value = Object.values(attribute)[0]
        let updateObj = {}

        updateObj.attributes = {}
        updateObj.attributes[key] = value

        axios.post('/cart/update.js', updateObj).then(response => {
            console.dir(response.data)
            localStorage.setItem(key, value)
        }).catch(error => {
            console.error(error)
        })
    }

    _updateCustomerObject (choice) {
        let optInObj = {
            customer: {
                id: this._customer_id,
                accepts_marketing: choice,
                marketing_opt_in_level: 'confirmed_opt_in'
            }
        }

        let jsonString = JSON.stringify(optInObj)
        console.log(jsonString)

        axios.put(`/admin/api/2019-10/customers/${this._customer_id}.json`, jsonString).then(response => {
            console.dir(response.data)
            // localStorage.setItem(key, value)
        }).catch(error => {
            console.error(error)
        })
    }
}

export default Checkout



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Checkout.js